import { UNIT } from '~/environment-variables/unit.const'
import type { Column } from '~/ui/Table/types'

const accountColumns: Array<Column> = [
  {
    name: 'TYPE',
    field: 'ADDRT',
  },
  {
    name: 'ADDRESS',
    field: 'ADDR',
  },
  {
    name: 'BALANCE',
    field: 'balance',
    isHoverable: true,
    unit: UNIT,
  },
  {
    name: 'BALANCE (%)',
    field: 'balancePercent',
    isHoverable: true,
    unit: '%',
  },
  {
    name: 'TXN COUNT',
    field: 'transactionCount',
  },
]

export { accountColumns }